export default __webpack_public_path__ + "static/Plots0043-eda5d87859f7bc03c1ed18f5f7022a48.jpg";